'use strict';

/* eslint no-undef: "off" */
/**
 * delete wishlist api
 */
define('deleteWishlistApi',['baseApiGet'], function (baseApiGet) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return baseApiGet('/rest/V1/xmapi/deletewishlistitem', params, { setCache: ['wishlist'] });
  };
});
